import { t } from "i18next";

export class UnitType {
  static OTHER = new UnitType(0, t("main.other"));
  static APARTMENTS = new UnitType(1, t("main.apartments"));
  static OFFICE = new UnitType(2, t("main.office"));
  static RESTAURANT = new UnitType(3, t("main.restaurant"));
  static STORAGE = new UnitType(4, t("main.storage"));
  static CAR = new UnitType(5, t("main.car"));
  static OUTSIDEAREA = new UnitType(6, t("main.outsideArea"));
  static STORE = new UnitType(7, t("main.store"));
  static PRODUCTION = new UnitType(8, t("main.production"));
  static HEALTHSERVICES = new UnitType(9, t("main.healthServices"));
  static GYM = new UnitType(10, t("main.gym"));
  static HAIRSALON = new UnitType(11, t("main.hairSalon"));
  static WORKSHOP = new UnitType(12, t("main.workshop"));
  static PARKING = new UnitType(13, t("main.parking"));

  static ALL_TYPES: UnitType[] = [
    UnitType.OTHER,
    UnitType.APARTMENTS,
    UnitType.OFFICE,
    UnitType.RESTAURANT,
    UnitType.STORAGE,
    UnitType.CAR,
    UnitType.OUTSIDEAREA,
    UnitType.STORE,
    UnitType.PRODUCTION,
    UnitType.HEALTHSERVICES,
    UnitType.GYM,
    UnitType.HAIRSALON,
    UnitType.WORKSHOP,
    UnitType.PARKING,
  ];

  id: number;
  title: string;

  constructor(id: number, title: string) {
    this.id = id;
    this.title = title;
  }

  static getType(id: any): UnitType {
    if (id instanceof UnitType) return id;
    id = typeof id === "number" ? id : typeof id === "string" ? parseInt(id) : undefined;
    for (let type of this.ALL_TYPES) {
      if (type.id === id) return type;
    }
    return UnitType.OTHER;
  }

  static getTypeWithName(name: string): UnitType {
    for (let type of this.ALL_TYPES) {
      if (type.title.toLowerCase() === name.toLowerCase()) return type;
    }
    return UnitType.OTHER;
  }

  static getAllNames(): string[] {
    let names: string[] = [];
    this.ALL_TYPES.forEach((type) => {
      names.push(type.title);
    });
    return names;
  }
}
